import styled from "styled-components";

export const CardFieldTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  font-weight: bold;
`;